import LogsIntegracao from '@pages/LogsIntegracao/LogsIntegracao'

export default LogsIntegracao;
